const useConvertSlug = () => {
  // Check if there is an ending whitespace
  // If so, remove it
  // @var string	-> string to check
  // @var c1 		-> character to check for
  const checkAndRemoveEndingCharacter = (string, c1) => {
    if (string.lastIndexOf(c1) === string.length - 1) {
      string.slice(0, -1);
    }
    return string;
  };

  // Count number of occurrances of a specific character in a string
  const countCharacter = (string, character) => {
    let count = 0;

    for (let i = 0; i < string.length; i++) {
      if (string.charAt(i) === character) {
        count += 1;
      }
    }
    return count;
  };

  // Replace characters
  const replaceCharacter = (str, c1, c2, c3) => {
    // Base Case
    // If the string is empty
    if (str.length === 1) {
      return str;
    }
    var x = str.charAt(0);
    // If the character at starting
    // of the given string is equal
    // to c1 or c3, replace it with c2
    if (str.charAt(0) === c1 || str.charAt(0) === c3) {
      x = c2;
      str = c2 + str.substring(1);
    }

    // Getting the answer from recursion
    // for the smaller problem
    return x + replaceCharacter(str.substring(1), c1, c2, c3);
  };

  // Capitalize each word in string
  const capitalizeWords = (string) => {
    let result;
    result = string
      .toLowerCase()
      .split(" ")
      .map((c) => c.charAt(0).toUpperCase() + c.substring(1))
      .join(" ");

    return result;
  };

  // Replace character at specific index
  const replaceCharacterAtIndex = (string, index, replacement) => {
    if (index > string.length - 1) return string;
    return (
      string.substring(0, index) + replacement + string.substring(index + 1)
    );
  };

  const convertFromSlug = (string) => {
    var c1 = "-",
      c2 = " ",
      c3 = "/";
    let result;

    if (countCharacter(string, c1) > 1) {
      // Case 2:
      // See if there are more than one '-'
      // If so, replace them with whitespace, get index of last occurrence of ' '
      // Capitalize each word
      // Replace last whitespace with backslash
      let subStr;
      subStr = replaceCharacter(string, c1, c2);

      const index = subStr.lastIndexOf(c2);

      subStr = capitalizeWords(subStr);
      subStr = replaceCharacterAtIndex(subStr, index, c3);

      result = subStr;
    } else if (countCharacter(string, c1) === 1) {
      // Case 1:
      // If there is only one dash,
      // Replace dash with whitespace
      // Capitalize words
      let subStr = replaceCharacter(string, c1, c2);
      subStr = capitalizeWords(subStr);
      result = subStr;
    } else {
      // Base case, no dash
      result = capitalizeWords(string);
    }

    return result;
  };

  const convertToSlug = (string) => {
    let result;
    var c1 = " ",
      c2 = "-",
      c3 = "/";
    // Check if ending character is a whitespace, if so remove it
    result = checkAndRemoveEndingCharacter(string, c1);

    if (
      (string.includes(c1) && string.includes(c3)) ||
      countCharacter(string, c1) > 1
    ) {
      // Case 2:
      // If string includes both whitespace and backslash
      // Replace them with a dash
      // Set every character to lower case
      let subStr = replaceCharacter(string, c1, c2, c3);
      result = subStr.toLowerCase();
    } else if (countCharacter(string, c1) === 1) {
      // Case 1:
      // If there is only a whitespace
      // Replace with dash
      // Set every character to lower case
      let subStr = replaceCharacter(string, c1, c2);
      result = subStr.toLowerCase();
    } else {
      result = result.toLowerCase();
    }

    return result;
  };

  return {
    convertFromSlug,
    convertToSlug,
  };
};
export default useConvertSlug;
